// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 8px;
}

.error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.error-title {
  font-size: 1.5rem;
  color: #c53030;
  margin: 0 0 0.75rem 0;
  font-weight: 600;
}

.error-message {
  font-size: 1rem;
  color: #742a2a;
  margin: 0 0 1.5rem 0;
  max-width: 500px;
  line-height: 1.5;
}

.error-retry-button {
  padding: 0.75rem 1.5rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.error-retry-button:hover {
  background-color: #c82333;
  transform: translateY(-1px);
}

.error-retry-button:active {
  transform: translateY(0);
}

.error-fullscreen {
  min-height: 60vh;
}

.error-inline {
  padding: 2rem 1rem;
}

@media (max-width: 768px) {
  .error-icon {
    font-size: 2.5rem;
  }

  .error-title {
    font-size: 1.25rem;
  }

  .error-message {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorMessage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  text-align: center;\n  background-color: #fff5f5;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n}\n\n.error-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.error-title {\n  font-size: 1.5rem;\n  color: #c53030;\n  margin: 0 0 0.75rem 0;\n  font-weight: 600;\n}\n\n.error-message {\n  font-size: 1rem;\n  color: #742a2a;\n  margin: 0 0 1.5rem 0;\n  max-width: 500px;\n  line-height: 1.5;\n}\n\n.error-retry-button {\n  padding: 0.75rem 1.5rem;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.error-retry-button:hover {\n  background-color: #c82333;\n  transform: translateY(-1px);\n}\n\n.error-retry-button:active {\n  transform: translateY(0);\n}\n\n.error-fullscreen {\n  min-height: 60vh;\n}\n\n.error-inline {\n  padding: 2rem 1rem;\n}\n\n@media (max-width: 768px) {\n  .error-icon {\n    font-size: 2.5rem;\n  }\n\n  .error-title {\n    font-size: 1.25rem;\n  }\n\n  .error-message {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
